<template>
    <a :href="job.url" class="card">
        <header class="card__header">
            <h5 class="card__title">{{ job.title }}</h5>
            <div class="card__actions">
                <more-navigation @toggle="onOptionsToggle" class="card__options" ref="navigation" orientation="horizontal">
                    <li class="dropdown-menu__item">
                        <a href="#" @click.prevent.stop="archive" class="dropdown-menu__link dropdown-menu__link--danger">Archive job</a>
                    </li>
                    <li class="dropdown-menu__item">
                        <labels :job="job">
                            <span class="dropdown-menu__link">Manage labels</span>
                        </labels>
                    </li>
                </more-navigation>
                <transition name="pulse">
                    <count :key="notifications.length" v-if="showNotifications" :count="notifications.length"/>
                </transition>
            </div>
        </header>
        <last-activity v-if="job.last_activity" :activity="job.last_activity" class="card__activity"/>
        <ul v-if="job.labels.length > 0" class="card__labels">
            <li class="card__labels__item" :key="index" v-for="(label, index) in job.labels">
                <span @click.prevent="filterByLabel(label)" class="label" :class="{[`label--${label.color}`]: true}">{{ label.name }}</span>
            </li>
        </ul>
        <div v-if="job.required_at" class="card__duedate" :class="{ 'card__duedate--overdue' : isOverdue }">
            <icon type="calendar" color="bluegray" size="12"/>
            Due <span>{{ job.required_at | formattedDate }}</span>
        </div>
        <footer v-if="showFooter" class="card__footer">
            <aside class="card__members members">
                <span @click.prevent="filterByUser(member.user)" v-for="member in job.members" :key="member.id">
                    <avatar  class="lc-member-item"  :user="member.user"/>
                </span>
            </aside>
        </footer>
    </a>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import LastActivity from './LastActivity'
import Count from './Count'
import Icon from '../Global/Icon'
import Avatar from '../Global/Avatar'
import MoreNavigation from '../Global/MoreNavigation'
import Labels from '../Global/Labels'

export default {
    props: {
        job: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            isOptionsOpen: false
        }
    },

    filters: {
        formattedDate (date) {
            return moment(date).format('DD MMM')
        }
    },

    methods: {
        onOptionsToggle (isOpen) {
            this.isOptionsOpen = isOpen
        },

        archive () {
            this.$store.dispatch('channel/archiveJob', this.job)
        },

        filterByLabel (label) {
            this.$store.dispatch('channel/clearFilters')
            this.$store.dispatch('channel/toggleFilter', { filter: 'labels', value: label.id })
        },

        filterByUser (user) {
            this.$store.dispatch('channel/clearFilters')
            this.$store.dispatch('channel/toggleFilter', { filter: 'users', value: user.id })
        }
    },

    computed: {
        ...mapGetters('notifications', ['jobNotifications']),

        notifications () {
            return this.jobNotifications(this.job.id)
        },

        hasUpdates () {
            return this.notifications.length > 0
        },

        isOverdue () {
            return moment().diff(this.job.required_at, 'hours') > 0
        },

        showFooter () {
            return this.job.members.length > 0
        },

        showNotifications () {
            return this.hasUpdates && this.isOptionsOpen === false
        }
    },

    components: {
        LastActivity,
        Count,
        Icon,
        Avatar,
        MoreNavigation,
        Labels
    }
}
</script>
